<template>
  <vs-popup class="add-new-company-holiday"
            id="popup"
            :title="titleFactory() + ' SUNDRY ORDERS'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateQcTest)" autocomplete="off">

          <vs-table :onlyClickCheckbox="true" stripe multiple v-model="selectedRms" @selected="handleSelected"  :data="items">

            <template slot="thead">
              <vs-th width="15%">ITEM CODE</vs-th>
              <vs-th width="15%">QUANTITY (KG)</vs-th>
              <vs-th width="15%">SOLD IN</vs-th>
              <vs-th width="15%">UNIT PRICE (GBP)</vs-th>
              <vs-th width="15%"  class="justify-end ml-auto mr-0">TOTAL PRICE (GBP)</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].sundry_item_code">
                  {{ data[indextr].sundry_item_code }}
                </vs-td>

                <vs-td :data="data[indextr].quantity">
                  {{ data[indextr].quantity }}
                </vs-td>

                <vs-td :data="data[indextr].sold_in">
                  {{ data[indextr].sold_in }}
                </vs-td>

                <vs-td :data="data[indextr].price">
                  {{ (Number(data[indextr].price)).toFixed(2) }}
                </vs-td>

                <vs-td  class="flex justify-end mr-4" :data="data[indextr].price">
                  {{data[indextr].quantity ? (Number(data[indextr].price) * data[indextr].quantity).toFixed(2) : '0.00'}}
                </vs-td>

              </vs-tr>
            </template>

          </vs-table>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Submit</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const SundrySupplierRepository = RepositoryFactory.get('sundry');

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";

  function initialState() {
    return {
      open: false,
      id: '',
      form: {},
      isCreateMode: true,
      status: '',
      items: [],
      selectedRms: [],
      test_types: [
        {name: 'Do No Sample', value: 'in:Do_No_Sample'},
        {name: 'Odour and Appearance Check', value: 'Odour_and_Appearance_Check'},
        {name: 'Taste Odour and Appearance Check', value: 'Taste_Odour_and_Appearance_Check'},
        {name: 'Odour Appearance SG and RI Check', value: 'Odour_Appearance_SG_and_RI_Check'}
      ]
    }
  }

  export default {
    name: 'AddQcTestRmOrderItemPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(id, status, items) {
        try {
          await Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.id = id
          this.status = status
          this.items = items
          this.open = true;
        } catch (error) {

        }
      },
      handleSelected(data) {

      },
      async onClickCreateQcTest() {
        const vue = this;
        this.$vs.loading();
        try {
          const ids = this.selectedRms.map((n) => n.id)
          const payload = {sundry_item_order_item_id: ids}
          await SundrySupplierRepository.changeSundryItemOrderStatus(this.id, this.status, payload)
          this.showSuccessMessage('Status change successfully!')
          await vue.$parent.fetchSundryItemOrders();
          this.open = false;
        } catch (e) {
          this.$vs.loading.close();
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      titleFactory() {
        switch (this.status) {
            case 'part_dispatched':
              return 'PART DISPATCHED'
            case 'part_received':
              return 'PART RECEIVED'
            case 'part_return':
              return 'PART RETURN'
        }
      }
    },
    components: {
      flatPickr,
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-company-holiday >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 60% !important;
  }

</style>
